import React, { useEffect, useRef, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import ExternalDataService from ".././../services/external.service";
import {
  logPlayerImgUpload,
  logPlayerImgFailure,
  pickApiMessage,
  redactPresignedInApiPayload,
  summarizePresignedUrl,
  getCroppedImageSourceInfo,
} from "../../utils/playerImgUploadLog";
import Demo from "../crop/Demo";
import {
  teamlistData,
  playerlistData,
  setisfirsttime,
  actlistData,
} from "../../actions/index";
import { useMediaQuery } from "react-responsive";
import $ from "jquery";
import { playerdefaultLogo } from "../../constants/Images";
import { FirebaseContext } from "../../FirebaseContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { bat } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper } from "../../constants/Images";
import moment from "moment";
import {
  getDatabase,
  ref,
  remove,
  onValue,
  set,
  update,
} from "firebase/database";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from "../utils/Demo";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { confirmPasswordReset } from "firebase/auth";

// Styled components for QR payment section
const QRContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  background-color: #f9f9f9;
`;

const QRImageWrapper = styled.div`
  text-align: left;
  margin-right: 20px;
`;

const QRImage = styled.img`
  width: 130px;
  height: 130px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 5px;
  background-color: white;
`;

const QRDetailsWrapper = styled.div`
  flex: 1;
  text-align: left;
`;

const QRSectionTitle = styled.h4`
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
`;

const QRDetailRow = styled.div`
  margin-bottom: 8px;
`;

const QRDetailLabel = styled.label`
  font-weight: bold;
  color: #555;
  display: inline-block;
  width: 100px;
`;

const QRDetailValue = styled.span`
  color: #333;
`;

const QRFeeValue = styled.span`
  color: #e53e3e;
  font-weight: bold;
`;

const QRInstructions = styled.div`
  margin-top: 15px;
  font-size: 13px;
  color: #666;
`;

function Addplayers(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setplayerlistData);
  // const getpageData = useSelector((state) => state.setplayerlistData);
  const getTeamList = useSelector((state) => state.setteamlistData);
  const aucmoredetail = useSelector((state) => state.actmoredata);

  useEffect(() => {
    console.log("aucmoredetail");
    console.log(aucmoredetail);
    setPyqr(aucmoredetail?.pyqr);
  }, [aucmoredetail]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);

  const [batting, setBatting] = useState("");
  const [bowling, setBowling] = useState("");
  const [extra, setextra] = useState(aucmoredetail?.extra);
  const [sp3, setsp3] = useState("");
  const [otherBatting, setOtherBatting] = useState(false);
  const [otherBowling, setOtherBowling] = useState(false);
  const [othersp3, setOthersp3] = useState(false);
  const [playingStyle, setPlayingStyle] = useState("batsman");
  const [croppedImage, setCroppedImage] = useState("");
  const [originalFileName, setOriginalFileName] = useState("");
  const [pyqr, setPyqr] = useState(null);
  const [customTag, setCustomTag] = useState("");

  const [cid, setCid] = useState(loginuser["cid"]);
  const [isUploading, setIsUploading] = useState(false);

  const [isOwner, setIsOwner] = useState("");
  const [defaultIsOwner, setDefaultIsOwner] = useState(false);
  const [isNonPlayer, setIsNonPlayer] = useState(false);
  const [playerSoldToTeam, setPlayerSoldToTeam] = useState(false);
  const [points, setPoints] = useState("");
  const [catData, setcatData] = useState([]);
  const [sp1opt, setsp1opt] = useState([
    "All Rounder",
    "Batting All Rounder",
    "Bowling All Rounder",
    "All Rounder Wicketkeeper",
    "Batsman",
    "Bowler",
    "Wicket Keeper",
    "Batter",
    "Other",
  ]);
  const [sp2opt, setsp2opt] = useState([
    "Right Hand",
    "Left Hand",
    "Right Hand Batsman",
    "Left Hand Batsman",
    "Right Hand Opener",
    "Left Hand Opener",
    "Right Hand Middle Order",
    "Left Hand Middle Order",
    "Other",
  ]);
  const [sp3opt, setsp3opt] = useState([
    "Right Arm Fast",
    "Right Arm Medium",
    "Left Arm Fast",
    "Left Arm Medium",
    "Off-Break",
    "Leg-Break",
    "Left Arm Orthodox",
    "Left Arm Chinaman",
    "Other",
  ]);

  const [catid, setcatid] = useState("");
  const [tagid, settagid] = useState("");
  const [isbat, setisbat] = useState(false);
  const [isbol, setisbol] = useState(false);
  const [isremove, setisremove] = useState(false);
  const [iswkeep, setiswkeep] = useState(false);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const updtoken = useSelector((state) => state.updtoken);

  const history = useHistory({ forceRefresh: true });
  var savenew = 0;
  let logo_pic = "";
  const aid = localStorage.getItem("auction_id");
  const [auctype, setauctype] = useState(
    getaucpageData != 0 &&
    getaucpageData.responsedata.list.filter((ele) => ele.aid == aid)[0]
      .acttype
  );

  const fetchcatData = async () => {
    //  console.log("andr aaaya")
    //  console.log(aid)

    // setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listCategory({ aid: aid }, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log(response);

        if (response.success == true) {
          let responsedata = response.data;
          //  console.log(" cat list kya h");
          //  console.log(responsedata);
          setcatData(responsedata.list);
        }
        // setActive(false);
      })
      .catch(() => {
        //  console.log('Not valid')
        // setActive(false);
      });
  };
  const fetchTeamData = async () => {
    var hdr = {
      params: {
        frm: 1,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listTeam({}, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;

          // setTeamData(responsedata.list);
          // setteampath(responsedata.path);
          dispatch(teamlistData({ responsedata }));
        }
      })
      .catch(() => {
        //  console.log("Not valid");
      });
  };

  const onSubmit = async (values) => {
    if (isUploading) return;

    setIsUploading(true);
    if (tagid === "7" && !customTag.trim()) {
      toast.error("Custom tag is required when Other is selected", {
        theme: "colored",
      });
      setIsUploading(false);
      return;
    }
    if (playerSoldToTeam && (!isOwner || isOwner === "" || Number(isOwner) < 1)) {
      toast.error("Please select a team when Player sold to team is checked", {
        theme: "colored",
      });
      setIsUploading(false);
      return;
    }
    //  console.log('jiii')
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    var icon = "";
    if (isbat == true) {
      if (icon == "") {
        icon += "bat.png";
      } else {
        icon += ",bat.png";
      }
    }
    if (isbol == true) {
      if (icon == "") {
        icon += "ball.png";
      } else {
        icon += ",ball.png";
      }
    }
    if (iswkeep == true) {
      if (icon == "") {
        icon += "gloves.png";
      } else {
        icon += ",gloves.png";
      }
    }

    values["icons"] = icon;
    // values["logo_pic"] = croppedImage;
    values["isowner"] = isOwner;
    values["isnonplay"] = isNonPlayer;
    values["player_sold_to_team"] = playerSoldToTeam ? "1" : "0";
    values["points"] = points;
    if (auctype == 0) {
      values["spcf1"] = batting;
      values["spcf2"] = bowling;
      values["spcf3"] = sp3;
    }
    values["chkowner"] = defaultIsOwner == true ? 1 : 0;
    if (values["ownertag"] == undefined) {
      values["ownertag"] = "";
    }

    // Only call external API if a logo is selected
    if (croppedImage && croppedImage !== "" && croppedImage !== "#") {
      // Use auction detail (aucmoredetail) from Redux – already loaded from /dataapi/auction/detail for this aid; no extra API call.
      // data.no_presignimg === 1 → bypass S3, direct server upload; otherwise use S3 presigned.
      const noPresignImg = aucmoredetail?.data?.no_presignimg ?? aucmoredetail?.no_presignimg;
      if (noPresignImg !== 1) {
        const filename = originalFileName;
        const imgLogCtx = { logContext: "Addplayers" };

        const formData = new FormData();
        formData.append("filename", filename);
        formData.append("fltyp", "playerimg");

        logPlayerImgUpload("presign_flow_start", {
          ...imgLogCtx,
          aid,
          requestedFilename: filename,
          fltyp: "playerimg",
          cropSource: getCroppedImageSourceInfo(croppedImage),
          noPresignImg,
        });

        let externalResponse;
        try {
          externalResponse = await ExternalDataService.getSignedUrl(
            formData,
            hdr
          );

          logPlayerImgUpload("presign_api_http_done", {
            ...imgLogCtx,
            httpStatus: externalResponse?.status,
            apiSuccess: externalResponse?.data?.success,
            apiBodyRedacted: redactPresignedInApiPayload(externalResponse?.data),
          });

          if (externalResponse.data.success == true) {
            const presignPayload = externalResponse.data.data;
            if (!presignPayload || typeof presignPayload !== "object") {
              logPlayerImgFailure(
                "after presign API: success true but data missing",
                "response.data.data is empty or not an object",
                {
                  ...imgLogCtx,
                  aid,
                  httpStatus: externalResponse?.status,
                  apiBodyRedacted: redactPresignedInApiPayload(
                    externalResponse?.data
                  ),
                }
              );
              throw new Error("Presign response missing data object");
            }

            const { presignedUrl, filename: serverFilename } = presignPayload;

            if (!presignedUrl || typeof presignedUrl !== "string") {
              logPlayerImgFailure(
                "after presign API: no presignedUrl",
                "presignedUrl missing or not a string (cannot PUT to S3)",
                {
                  ...imgLogCtx,
                  aid,
                  serverFilename,
                  presignedUrlSummary: summarizePresignedUrl(presignedUrl),
                  apiBodyRedacted: redactPresignedInApiPayload(
                    externalResponse?.data
                  ),
                }
              );
              throw new Error("Presign response missing presignedUrl");
            }

            logPlayerImgUpload("presign_api_success", {
              ...imgLogCtx,
              requestedFilename: originalFileName,
              serverFilename,
              presignedUrlSummary: summarizePresignedUrl(presignedUrl),
            });

            let blob;
            try {
              const cropRes = await fetch(croppedImage);
              if (!cropRes.ok) {
                logPlayerImgFailure(
                  "crop image: fetch(croppedImage) HTTP not ok",
                  `HTTP ${cropRes.status} ${cropRes.statusText}`,
                  {
                    ...imgLogCtx,
                    aid,
                    cropSource: getCroppedImageSourceInfo(croppedImage),
                  }
                );
                throw new Error(
                  `Crop fetch failed: ${cropRes.status} ${cropRes.statusText}`
                );
              }
              blob = await cropRes.blob();
            } catch (blobErr) {
              logPlayerImgFailure(
                "crop image: data/blob conversion",
                blobErr?.message || String(blobErr),
                {
                  ...imgLogCtx,
                  aid,
                  name: blobErr?.name,
                  cropSource: getCroppedImageSourceInfo(croppedImage),
                }
              );
              throw blobErr;
            }

            logPlayerImgUpload("blob_ready_for_s3", {
              ...imgLogCtx,
              blobSizeBytes: blob.size,
              blobType: blob.type || "(empty)",
            });

            const uploadResponse = await fetch(presignedUrl, {
              method: "PUT",
              headers: {
                "Content-Type": blob.type,
                "x-amz-acl": "public-read",
              },
              body: blob,
            });

            logPlayerImgUpload("s3_put_finished", {
              ...imgLogCtx,
              ok: uploadResponse.ok,
              status: uploadResponse.status,
              statusText: uploadResponse.statusText,
              etag: uploadResponse.headers.get("etag"),
            });

            if (!uploadResponse.ok) {
              const errorText = await uploadResponse.text();
              logPlayerImgUpload("s3_put_failed", {
                ...imgLogCtx,
                status: uploadResponse.status,
                statusText: uploadResponse.statusText,
                bodyPreview: errorText?.slice?.(0, 500) ?? String(errorText),
              });
              logPlayerImgFailure(
                "S3 PUT (presigned URL)",
                `S3 returned not OK: ${uploadResponse.status} ${uploadResponse.statusText}`,
                {
                  ...imgLogCtx,
                  aid,
                  httpStatus: uploadResponse.status,
                  statusText: uploadResponse.statusText,
                  s3ErrorBodyPreview:
                    errorText?.slice?.(0, 500) ?? String(errorText),
                  blobSizeBytes: blob.size,
                  blobType: blob.type,
                  presignedHost: summarizePresignedUrl(presignedUrl).host,
                }
              );
              throw new Error("Failed to upload file to S3: " + errorText);
            }

            values["img"] = serverFilename;
            logPlayerImgUpload("presign_flow_complete", {
              ...imgLogCtx,
              serverFilename,
            });
          } else {
            const apiData = externalResponse?.data;
            const serverMsg = pickApiMessage(apiData);
            logPlayerImgUpload("presign_api_rejected", {
              ...imgLogCtx,
              httpStatus: externalResponse?.status,
              apiSuccessField: apiData?.success,
              serverMsg,
              apiBodyRedacted: redactPresignedInApiPayload(apiData),
            });
            logPlayerImgFailure(
              "getSignedUrl API",
              serverMsg ||
                "success was not true — presigned URL not issued (check serverMsg / apiBodyRedacted)",
              {
                ...imgLogCtx,
                aid,
                requestedFilename: filename,
                httpStatus: externalResponse?.status,
                apiSuccess: apiData?.success,
                serverMsg,
                apiBodyRedacted: redactPresignedInApiPayload(apiData),
              }
            );
            toast.error("External upload failed", { theme: "colored" });
            toast.dismiss(toastContainerId);
            setDisabled(false);
            return;
          }
        } catch (error) {
          logPlayerImgUpload("presign_flow_error", {
            ...imgLogCtx,
            name: error?.name,
            message: error?.message,
          });
          logPlayerImgFailure(
            "presign flow (network / axios / S3 / crop)",
            error?.message || String(error),
            {
              ...imgLogCtx,
              aid,
              requestedFilename: filename,
              errorName: error?.name,
              axiosHttpStatus: error?.response?.status,
              axiosStatusText: error?.response?.statusText,
              axiosDataPreview:
                error?.response?.data != null
                  ? typeof error.response.data === "string"
                    ? error.response.data.slice(0, 400)
                    : JSON.stringify(error.response.data).slice(0, 400)
                  : undefined,
            }
          );
          toast.error("External upload failed", { theme: "colored" });
          toast.dismiss(toastContainerId);
          setDisabled(false);
          return;
        }
      } else {
        logPlayerImgUpload("direct_upload_path_no_presign", {
          logContext: "Addplayers",
          aid,
          noPresignImg,
          cropSource: getCroppedImageSourceInfo(croppedImage),
          note: "image sent as logo_pic to addPlayer, no S3 presign",
        });
        values["logo_pic"] = croppedImage;
      }
    }

    extra.forEach((item, index) => {
      const fieldName = `extra_${index}`;
      const value = watch(fieldName); // Get the value from the form
      if (value) {
        values[fieldName] = value; // Add the value to the payload
      }
    });

    console.log("pl submited");
    console.log(values);
    DataService.addPlayer(values, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log('new entry')
        //  console.log(response)
        toast.dismiss(toastContainerId);
        //  console.log("values")
        //  console.log(values["catid"])
        if (response.success == true) {
          const db = getDatabase();
          // Ensure spcf1, spcf2, spcf3 are not undefined before setting to Firebase
          // Firebase does not allow undefined values in objects

          // Helper function to safely get value or null/empty string
          const safeValue = (val, fallback = "") =>
            typeof val !== "undefined" ? val : fallback;

          // Prepare detail object with no undefined values
          const detailObj = {
            age: safeValue(values.age, ""),
            base: safeValue(values.base, ""),
            catid: safeValue(values.catid, ""),
            fname: safeValue(values.fname, ""),
            icons: safeValue(values.icons, ""),
            detail: safeValue(values.detail, ""),
            isnonplay: safeValue(values.isnonplay, 0),
            isowner: safeValue(values.isowner, 0),
            player_sold_to_team: safeValue(values.player_sold_to_team, 0),
            points: safeValue(values.points, ""),
            jrnm: safeValue(values.jrno, ""),
            img: safeValue(values.logo_pic, ""),
            mob: safeValue(values.mob, ""),
            ownertag: safeValue(values.ownertag, ""),
            pcode: safeValue(response.data.new.pcode, ""),
            pid: safeValue(response.data.pid, ""),
            pname: safeValue(values.pname, ""),
            spcf1: safeValue(values.spcf1, ""), // fallback to "" if undefined
            spcf2: safeValue(values.spcf2, ""),
            spcf3: safeValue(values.spcf3, ""),
            trouser: safeValue(values.trouser, ""),
            tshirt: safeValue(values.tshirt, ""),
          };

          // Remove any keys with undefined values (extra safety)
          Object.keys(detailObj).forEach((key) => {
            if (typeof detailObj[key] === "undefined") {
              detailObj[key] = "";
            }
          });

          console.log("values2222");

          set(ref(db, "map/info/" + aid), {
            type: "4",
            upd: "1",
            id: response.data.pid,
            detail: detailObj,
            tkn: updtoken,
          });

          console.log("values33333");
          console.log(response.data);
          let submitdata = [response.data.new];

          let responsedata = {};
          if (getpageData == 0) {
            responsedata = {
              responsedata: {
                path: response.data.path,
                aid: aid,
                list: [...submitdata],
              },
            };
          } else {
            responsedata = {
              responsedata: {
                path: response.data.path,
                aid: aid,
                list: [...submitdata, ...getpageData.responsedata.list],
              },
            };
          }
          dispatch(playerlistData(responsedata));

          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          if (savenew == 0) {
            history.push(BASE_PATH + "auction-players");
          } else {
            reset();
            setcatid("");
            setisbat(false);
            setisbol(false);
            setiswkeep(false);
            settagid("");
            setIsOwner("");
            setValue("pcode", "");
            setValue("mob", "");
            setValue("pname", "");
            setValue("fname", "");
            setValue("dob", "");
            setValue("tshirt", "");
            setValue("trouser", "");
            setValue("detail", "");
            setCroppedImage("");
            setDefaultIsOwner("");

            setValue("wkeep", 0);
            $(".crop-default img").attr("src", playerdefaultLogo);
          }
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
        setIsUploading(false);
      })
      .catch((error) => {
        console.log("error");
        console.log(error);

        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
        setIsUploading(false);
      });

  };

  useEffect(() => {
    if (match?.ownertag || match?.cus_tag) {
      if (match.ownertag === "7" && match.cus_tag) {
        settagid("other");
        setCustomTag(match.cus_tag);
      } else {
        settagid(match.ownertag || "0");
        setCustomTag("");
      }
    }
    console.log("aucmoredetail");
    console.log(aucmoredetail);
    fetchTeamData();
    //  console.log('hhhh')

    $(".crop-default img").attr("src", playerdefaultLogo);
    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });
    fetchcatData();
  }, [Demo]);

  useEffect(() => {
    const isFirstMount = localStorage.getItem("isFirstMount");
    //  console.log('isFirstMount')
    //  console.log(isFirstMount)
    if (!isFirstMount) {
      localStorage.setItem("isFirstMount", false);
    } else {
      localStorage.removeItem("isFirstMount");
      history.push("/auction-detail");
    }
  }, [history]);
  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
  };
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);

  var batstyle = {
    backgroundColor: "white",
  };
  var bolstyle = {
    backgroundColor: "white",
  };
  var wkeepstyle = {
    backgroundColor: "white",
  };
  if (isbat == true) {
    batstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: "3px solid #3e71a3",
    };
  }
  if (isbol == true) {
    bolstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: "3px solid #3e71a3",
    };
  }
  if (iswkeep == true) {
    wkeepstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: "3px solid #3e71a3",
    };
  }
  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row myclass1">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          {/* <Link to="/newplayerform">N</Link> */}
                          <div className="row">
                            <div className="col-md-12">
                              {" "}
                              <div className="col-xs-12 col-md-6 ">
                                <div className="form-group text-box-margin mobile-marginbt">
                                  <div className="col-md-4">
                                    {" "}
                                    <label
                                      htmlFor="crop-pic"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Profile Pic{/*logo*/}{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <div style={{ clear: "both" }}></div>
                                    <ImageCropper2
                                      croppedImage={croppedImage}
                                      defaultImage={playerdefaultLogo}
                                      setCroppedImage={setCroppedImage}
                                      setOriginalFileName={setOriginalFileName}
                                    />
                                    {/* {localStorage.getItem("crp_typ") == 0 ? (
                                      <ImageCropper2
                                        croppedImage={croppedImage}
                                        defaultImage={playerdefaultLogo}
                                        setCroppedImage={setCroppedImage}
                                        setOriginalFileName={
                                          setOriginalFileName
                                        }
                                      />
                                    ) : (
                                      <ImageCropper1
                                        croppedImage={croppedImage}
                                        defaultimage={playerdefaultLogo}
                                        setCroppedImage={setCroppedImage}
                                        setOriginalFileName={
                                          setOriginalFileName
                                        }
                                      />
                                    )} */}
                                    {/* <FontAwesomeIcon onClick={()=>{setisremove(true);setCroppedImage('');setisremove(false)}} className="remove_player_icon" icon={faXmark} />              */}
                                  </div>
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6">
                                {/* <div className="col-md-12"> */}
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    {" "}
                                    <label
                                      htmlFor="pcode"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Form No
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Enter Form Number"
                                      type="number"
                                      id="pcode"
                                      {...register("pcode", {})}
                                    />
                                  </div>
                                </div>
                                {/* </div> */}
                                {/* <div className="col-md-12 "> */}
                                {/* <div className="form-group text-box-margin">
                                  <div className="col-md-4 margin-top-14px">
                                    <label htmlFor="age"> Date of Birth </label>
                                  </div>
                                  <div className="col-md-8 margin-top-14px">
                                    {" "}
                                    <input
                                      className="form-control"
                                      type="date"
                                      id="date"
                                      {...register("dob", {})}
                                    />
                                  </div>
                                </div> */}
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4 margin-top-14px margintop-0px">
                                    <label
                                      htmlFor="age"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Age{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8 margin-top-14px margintop-0px">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control"
                                      type="number"
                                      id="age"
                                      {...register("age", {})}
                                    />
                                  </div>
                                </div>
                                {/* </div> */}
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="pname"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Name *{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control gg"
                                      placeholder="Enter Name"
                                      type="text"
                                      id="pname"
                                      {...register("pname", {
                                        required: true,
                                        required: "required field.",
                                      })}
                                    />
                                    {errors.pname && (
                                      <p className="text-error">
                                        {errors.pname.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4 ">
                                    <label
                                      htmlFor="fname"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Father Name{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8 ">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Enter Father Name"
                                      id="fname"
                                      type="text"
                                      {...register("fname", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-12">
                                {" "}
                                <div className="form-group text-box-margin ">
                                  <div className="col-md-2">
                                    {" "}
                                    <label
                                      htmlFor="mob"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Mobile No{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-4 margin-left-6px mobile-marginbt">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Mobile Number"
                                      type="number"
                                      id="mob"
                                      {...register("mob", {})}
                                    />
                                  </div>
                                  {catData != "" && (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin addpl-marginbt">
                                        <div className="col-md-4 addpl-padding">
                                          <label
                                            htmlFor="trouser"
                                            className="addpl-label"
                                          >
                                            {" "}
                                            Select Category{" "}
                                          </label>
                                        </div>
                                        <div className="col-md-8 addpl-padding">
                                          <select
                                            className="form-control addpl-select-control zxc"

                                            type="text"
                                            {...register("catid")}
                                            value={catid}
                                            onChange={(e) => {
                                              setcatid(e.target.value);
                                            }}
                                          >
                                            <option value="" selected>
                                              Select category
                                            </option>
                                            {catData?.map((ct) => (
                                              <option
                                                value={ct.cid}
                                                key={ct.cid}
                                              >
                                                {ct.cname}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner">
                                    <select
                                      className="form-control"
                                      type="text"
                                      {...register("catid")}
                                      value={
                                        catid
                                      }
                                      onChange={(e) => {
                                        setcatid(e.target.value);
                                      }}
                                    >
                                      <option value=""  selected>
                                        Select category
                                      </option>
                                      {catData?.map(
                                        (ct) => (
                                          <option
                                            value={ct.cid}
                                            key={ct.cid}
                                          >
                                            {ct.cname}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div> */}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin">

                                  {/* TAG / OWNER LABEL */}
                                  <div className="isowner-div">
                                    <div className="col-xs-8 col-sm-3 col-md-2 margin-top-14px margintop-0px">
                                      <label htmlFor="isowner" className="addpl-label">Tag/Owner</label>
                                    </div>
                                  </div>

                                  {/* SELECT TAG */}
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner hyyy">
                                    <select
                                      className="form-control addpl-select-control"
                                      {...register("ownertag")}
                                      value={tagid}
                                      onChange={(e) => settagid(e.target.value)}
                                    >
                                      <option value="0">Select tag</option>
                                      <option value="1">Owner</option>
                                      <option value="2">Co-owner</option>
                                      <option value="3">Captain</option>
                                      <option value="6">Vice Captain</option>
                                      <option value="4">Icon</option>
                                      <option value="5">Retain</option>
                                      <option value="7">Other</option>
                                    </select>
                                  </div>

                                  {/* SELECT TEAM */}
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner">
                                    <select
                                      className="form-control addpl-select-control"
                                      id="isowner"
                                      value={isOwner > 1 ? isOwner : ""}
                                      onChange={(e) => setIsOwner(e.target.value)}
                                      disabled={tagid === "0" || !tagid}
                                    >
                                      <option value="">Select Team</option>
                                      {getTeamList?.responsedata?.list?.map((team) => (
                                        <option value={team.tid} key={team.tid}>{team.name}</option>
                                      ))}
                                    </select>
                                  </div>

                                  {/* CUSTOM TAG */}
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner mt-4 hig">
                                    <input
                                      type="text"
                                      className="form-control addpl-select-control abc"
                                      placeholder="Custom tag"
                                      value={customTag}
                                      onChange={(e) => setCustomTag(e.target.value)}
                                      disabled={tagid === "0" || !tagid}
                                    />
                                  </div>


                                  {/* Is Non Playing Owner? + Player sold to team in one row; Points only when Player sold to team is checked - same as Edit players */}
                                  {tagid !== "0" && tagid !== "" && (
                                    <>
                                      <div className="col-xs-12 margin-top-14px-isowner" style={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: "wrap", gap: "16px", width: "42%" }}>
                                        <div className="nonplowner-block" style={{ flex: "1 1 auto", minWidth: "140px" }}>
                                          <label htmlFor="isnonplay" className="addpl-label vbn">Is Non Playing Owner?</label>
                                          <input
                                            className="form-control nonplowner-div"
                                            type="checkbox"
                                            id="isnonplay"
                                            checked={isNonPlayer}
                                            onClick={(e) => {
                                              const checked = e.target.checked;
                                              setIsNonPlayer(checked);
                                              if (checked) {
                                                setPlayerSoldToTeam(false);
                                                setPoints("0");
                                              }
                                            }}
                                          />
                                        </div>
                                        {!isNonPlayer && Number(isOwner) > 0 && (
                                          <div className="nonplowner-block" style={{ flex: "1 1 auto", minWidth: "140px" }}>
                                            <label htmlFor="playerSoldToTeam" className="addpl-label vbn">Player retained to team</label>
                                            <input
                                              className="form-control nonplowner-div"
                                              type="checkbox"
                                              id="playerSoldToTeam"
                                              checked={playerSoldToTeam}
                                              onChange={(e) => {
                                                const checked = e.target.checked;
                                                setPlayerSoldToTeam(checked);
                                                if (checked) setPoints("0");
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {!isNonPlayer && playerSoldToTeam && Number(isOwner) > 0 && (
                                        <>
                                          <div className="col-md-12 margin-top-14px margintop-0px">
                                            <div className="col-md-2">
                                              <label htmlFor="points" className="addpl-label">Points</label>
                                            </div>
                                            <div className="col-md-4 margin-left-6px mobile-marginbt">
                                              <input
                                                className="form-control addpl-input-control"
                                                type="text"
                                                inputMode="numeric"
                                                id="points"
                                                value={points}
                                                onChange={(e) => {
                                                  const v = e.target.value;
                                                  if (v === "" || /^\d+$/.test(v)) setPoints(v);
                                                }}
                                                placeholder="Enter points"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}

                                </div>
                              </div>
                            </div>

                            {auctype == 0 && (
                              <div className="col-md-12">
                                <div className="col-md-12 plstyle">
                                  <div className="col-sm-12 col-md-2 margin-top-14px margintop-0px">
                                    <label htmlFor="" className="addpl-label">
                                      {" "}
                                      Playing Style
                                    </label>
                                  </div>
                                  <div className="col-md-8 mobile-marginbt">
                                    <div
                                      className={`roleclass form-group text-box-margin ${isTabletOrMobile || isPortrait
                                          ? "row"
                                          : null
                                        }`}
                                    >
                                      <div className="">
                                        <img
                                          onClick={() => setisbat(!isbat)}
                                          src={bat}
                                          alt=""
                                          style={batstyle}
                                        />
                                      </div>
                                      <div className="">
                                        <img
                                          onClick={() => setisbol(!isbol)}
                                          src={ball}
                                          alt=""
                                          style={bolstyle}
                                        />
                                      </div>
                                      <div className="">
                                        <img
                                          onClick={() => setiswkeep(!iswkeep)}
                                          src={wkeeper}
                                          alt=""
                                          style={wkeepstyle}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-md-12  margin-top-14px margintop-0px">
                              {extra?.length > 0 &&
                                extra.map((item, index) => {
                                  if (item.o) {
                                    var dynamicoptions = item.o.split(",");
                                  }
                                  return (
                                    <div className="col-md-6  m-top-2">
                                      <div className="form-group text-box-margin addpl-marginbt">
                                        <div className="col-md-4">
                                          <label htmlFor="tshirt">
                                            {item.l}
                                          </label>
                                        </div>
                                        <div className="col-md-8">
                                          {item.t == "0" ? (
                                            <input
                                              placeholder={item.label}
                                              className="form-control"
                                              type="text"
                                              {...register(`extra_${index}`)}
                                            />
                                          ) : item.t == "1" ? (
                                            <input
                                              placeholder={item.label}
                                              className="form-control"
                                              type="number"
                                              {...register(`extra_${index}`)}
                                            />
                                          ) : item.t == "2" ? (
                                            <select
                                              className="form-control"
                                              id={item.label}
                                              type="text"
                                              {...register(`extra_${index}`)}
                                            >
                                              <option value="">
                                                --select--
                                              </option>
                                              {dynamicoptions?.map((el, ind) => {
                                                return (
                                                  <option value={el}>{el}</option>
                                                );
                                              })}
                                            </select>
                                          ) : item.t == "3" ? (
                                            <div className="checkbox-multi-container">
                                              <div className="checkbox-options-wrapper space-y-2">
                                                {dynamicoptions && dynamicoptions.length > 0 ? (
                                                  dynamicoptions.map((opt, optIndex) => (
                                                    <label
                                                      key={optIndex}
                                                      style={{
                                                        gap: "10px",
                                                        alignItems: 'center',
                                                        height: "20px"
                                                      }}
                                                      className="flex items-center space-x-2 cursor-pointer"
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        value={opt}
                                                        className="h-4 w-4"
                                                        {...register(`extra_${index}`)}
                                                      />
                                                      <span className="text-sm text-gray-700">{opt}</span>
                                                    </label>
                                                  ))
                                                ) : (
                                                  <p className="text-xs text-gray-500">No options configured</p>
                                                )}
                                              </div>
                                            </div>
                                          ) : item.t == "4" ? (
                                            <div className="file-input-container joinaucinput-control">
                                              <input
                                                type="file"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                className="form-control addinput-control"
                                                {...register(`extra_${index}`)}
                                              />
                                              <p className="text-xs text-gray-500 mt-1">
                                                Accepted: PDF, JPG, PNG (Max
                                                5MB)
                                              </p>
                                            </div>
                                          ) : item.t == "5" ? (
                                            <div className=" ">
                                              <input
                                                type="date"
                                                className="form-control addinput-control"
                                                placeholder={
                                                  item.p || "Select date"
                                                }
                                                {...register(`extra_${index}`)}
                                              />
                                            </div>
                                          ) : (
                                            <select
                                              className="form-control"
                                              id={item.label}
                                              type="text"
                                              {...register(`extra_${index}`)}
                                            >
                                              <option value="">
                                                --select--
                                              </option>
                                              {dynamicoptions?.map((el, ind) => {
                                                return (
                                                  <option value={el}>{el}</option>
                                                );
                                              })}
                                            </select>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                            {aucmoredetail &&
                              aucmoredetail.show &&
                              aucmoredetail.show.sp1 &&
                              aucmoredetail.show.sp1.show == 1 && (
                                <div className="col-md-12 margin-top-14px margintop-0px">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin addpl-marginbt">
                                      <div className="col-md-4">
                                        <label
                                          htmlFor="spcf1"
                                          className="addpl-label"
                                        >
                                          {" "}
                                          {aucmoredetail.show.sp1.label !== ""
                                            ? aucmoredetail.show.sp1.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            aucmoredetail.show.sp1.label.slice(
                                              1
                                            )
                                            : "Specification 1"}{" "}
                                        </label>
                                      </div>
                                      {auctype != 0 ? (
                                        <div className="col-md-8">
                                          {" "}
                                          <input
                                            placeholder={
                                              aucmoredetail.show.sp1.label !==
                                                ""
                                                ? aucmoredetail.show.sp1.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp1.label.slice(
                                                  1
                                                )
                                                : "Specification 1"
                                            }
                                            className="form-control addpl-select-control"
                                            type="text"
                                            {...register("spcf1", {})}
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-md-6">
                                          {" "}
                                          <select
                                            className="form-control addpl-select-control"
                                            id="spcf1"
                                            type="text"
                                            {...register("spcf1", {
                                              required: false,
                                              // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                              if (e.target.value === "Other") {
                                                setOtherBatting(true);
                                              } else {
                                                setOtherBatting(false);
                                              }
                                              setBatting(e.target.value);
                                            }}
                                          >
                                            <option value={""}>
                                              --
                                              {aucmoredetail.show.sp1.label !==
                                                ""
                                                ? aucmoredetail.show.sp1.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp1.label.slice(
                                                  1
                                                )
                                                : "Specification 1"}
                                              --
                                            </option>
                                            {/* <option value="Right Hand Batsman">
                                        Right Hand Batsman
                                      </option>
                                      <option value="Left Hand Batsman">
                                        Left Hand Batsman
                                      </option> */}
                                            {(
                                              aucmoredetail.show.sp1.opt == null ||
                                                aucmoredetail.show.sp1.opt.trim() === ""
                                                ? sp1opt
                                                : aucmoredetail.show.sp1.opt.split(",").map(o => o.trim()).filter(Boolean)
                                            ).map((ele, i) => (
                                              <option key={i} value={ele}>
                                                {ele}
                                              </option>
                                            ))}
                                          </select>
                                          {errors.spcf1 && (
                                            <p className="text-error">
                                              {errors.spcf1.message}
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {otherBatting ? (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            type="text"
                                            onChange={(e) =>
                                              setBatting(e.target.value)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}
                            {aucmoredetail &&
                              aucmoredetail.show &&
                              aucmoredetail.show.sp2 &&
                              aucmoredetail.show.sp2.show == 1 && (
                                <div className="col-md-12 margin-top-14px margintop-0px">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin addpl-marginbt">
                                      <div className="col-md-4">
                                        <label
                                          htmlFor="spcf2"
                                          className="addpl-label"
                                        >
                                          {" "}
                                          {aucmoredetail.show.sp2.label !== ""
                                            ? aucmoredetail.show.sp2.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            aucmoredetail.show.sp2.label.slice(
                                              1
                                            )
                                            : "Specification 2"}
                                        </label>
                                      </div>
                                      {auctype != 0 ? (
                                        <div className="col-md-8">
                                          {" "}
                                          <input
                                            placeholder={
                                              aucmoredetail.show.sp2.label !==
                                                ""
                                                ? aucmoredetail.show.sp2.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp2.label.slice(
                                                  1
                                                )
                                                : "Specification 2"
                                            }
                                            className="form-control addpl-select-control"
                                            id="spcf2"
                                            type="text"
                                            {...register("spcf2", {})}
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-md-6">
                                          {" "}
                                          <select
                                            className="form-control addpl-select-control"
                                            id="spcf2"
                                            type="text"
                                            {...register("spcf2", {
                                              required: false,
                                              // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                              if (e.target.value === "Other") {
                                                setOtherBowling(true);
                                              } else {
                                                setOtherBowling(false);
                                              }
                                              setBowling(e.target.value);
                                            }}
                                          >
                                            <option value={""}>
                                              --
                                              {aucmoredetail.show.sp2.label !==
                                                ""
                                                ? aucmoredetail.show.sp2.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp2.label.slice(
                                                  1
                                                )
                                                : "Specification 2"}
                                              --
                                            </option>
                                            {
                                              (aucmoredetail.show.sp2.opt == null || aucmoredetail.show.sp2.opt.trim() === "")
                                                ? (
                                                  batting === "Bowling All Rounder" || batting === "Bowler"
                                                    ? sp3opt.map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                    : sp2opt.map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                )
                                                : (
                                                  aucmoredetail.show.sp2.opt
                                                    .split(",")
                                                    .map(o => o.trim())
                                                    .filter(Boolean)
                                                    .map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                )
                                            }
                                            {/* <option value="Other">Other</option> */}
                                          </select>
                                          {errors.spcf2 && (
                                            <p className="text-error">
                                              {errors.spcf2.message}
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {otherBowling ? (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            type="text"
                                            onChange={(e) =>
                                              setBowling(e.target.value)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}

                            {aucmoredetail &&
                              aucmoredetail.show &&
                              aucmoredetail.show.sp3 &&
                              aucmoredetail.show.sp3.show == 1 && (
                                <div className="col-md-12 margin-top-14px margintop-0px">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin addpl-marginbt">
                                      <div className="col-md-4">
                                        <label
                                          htmlFor="spcf1"
                                          className="addpl-label"
                                        >
                                          {" "}
                                          {aucmoredetail.show.sp3.label !== ""
                                            ? aucmoredetail.show.sp3.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            aucmoredetail.show.sp3.label.slice(
                                              1
                                            )
                                            : "Specification 3"}
                                        </label>
                                      </div>
                                      {auctype != 0 ? (
                                        <div className="col-md-8">
                                          {" "}
                                          <input
                                            placeholder={
                                              aucmoredetail.show.sp3.label !==
                                                ""
                                                ? aucmoredetail.show.sp3.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp3.label.slice(
                                                  1
                                                )
                                                : "Specification 3"
                                            }
                                            className="form-control addpl-select-control"
                                            type="text"
                                            {...register("spcf3", {})}
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-md-6">
                                          {" "}
                                          <select
                                            className="form-control addpl-select-control"
                                            id="spcf3"
                                            type="text"
                                            {...register("spcf3", {
                                              required: false,
                                              // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                              if (e.target.value === "Other") {
                                                setOthersp3(true);
                                              } else {
                                                setOthersp3(false);
                                              }
                                              setsp3(e.target.value);
                                            }}
                                          >
                                            <option value={""}>
                                              --
                                              {aucmoredetail.show.sp3.label !==
                                                ""
                                                ? aucmoredetail.show.sp3.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp3.label.slice(
                                                  1
                                                )
                                                : "Specification 3"}
                                              --
                                            </option>
                                            {
                                              (aucmoredetail.show.sp3.opt == null || aucmoredetail.show.sp3.opt.trim() === "")
                                                ? (
                                                  batting === "Bowling All Rounder" || batting === "Bowler"
                                                    ? sp2opt.map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                    : sp3opt.map((ele) => (
                                                      <option value={ele}>
                                                        {ele}
                                                      </option>
                                                    ))
                                                )
                                                : (
                                                  aucmoredetail.show.sp3.opt
                                                    ?.split(",")
                                                    .map(o => o.trim())
                                                    .filter(Boolean)
                                                    .map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                )
                                            }

                                            {/* <option value="Other">Other</option> */}
                                          </select>
                                          {errors.spcf2 && (
                                            <p className="text-error">
                                              {errors.spcf2.message}
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {othersp3 ? (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            type="text"
                                            onChange={(e) =>
                                              setsp3(e.target.value)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    {" "}
                                    <label
                                      htmlFor="tshirt"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      T-shirt size{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    {/* <select
                                      className="form-control"
                                      type="text"
                                      id="tshirt"
                                      {...register("tshirt", {})}
                                    >
                                      <option value="">--select--</option>
                                      <option value="S">S</option>
                                      <option value="M">M</option>
                                      <option value="L">L</option>
                                      <option value="XL">XL</option>
                                      <option value="XXL">XXL</option>
                                      <option value="XXXL">XXXL</option>
                                    </select> */}
                                    <input
                                      placeholder="S/M/L/XL/XXL/XXXL"
                                      className="form-control addpl-input-control"
                                      type="text"
                                      {...register("tshirt", {
                                        maxLength: {
                                          value: 10,
                                          message:
                                            "Maximum 10 characters allowed.",
                                        },
                                      })}
                                    />
                                    {errors.tshirt && (
                                      <p className="text-error">
                                        {errors.tshirt.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    {" "}
                                    <label
                                      htmlFor="tshirt"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Jersey Name
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      placeholder="Jersey Name"
                                      className="form-control addpl-input-control"
                                      type="text"
                                      {...register("jrnm", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="jrno"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Jersey Number{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    <input
                                      placeholder="Jersey Number"
                                      className="form-control addpl-input-control"
                                      type="number"
                                      {...register("jrno", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="trouser"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Trouser Size{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {/* <select
                                      className="form-control"
                                      id="trouser"
                                      type="text"
                                      {...register("trouser", {})}
                                    >
                                      <option value="">--select--</option>
                                      <option value="S">S</option>
                                      <option value="M">M">M</option>
                                      <option value="L">L</option>
                                      <option value="XL">XL</option>
                                      <option value="XXL">XXL</option>
                                      <option value="XXXL">XXXL</option>
                                    </select> */}
                                    <input
                                      placeholder="S/M/L/XL/XXL/XXXL"
                                      className="form-control addpl-input-control"
                                      type="text"
                                      {...register("trouser", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-2">
                                    <label
                                      htmlFor="detail"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Detail{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8 margin-left-6px">
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Detail"
                                      type="text"
                                      id="detail"
                                      {...register("detail")}
                                    />

                                    {errors.detail && (
                                      <p className="text-error">
                                        {errors.detail.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-2">
                                    <label
                                      htmlFor="jrno"
                                      className="addpl-label"
                                    >
                                      Base Value
                                    </label>
                                  </div>
                                  <div className="col-md-3 margin-left-6px">
                                    <input
                                      placeholder="Base Value"
                                      className="form-control addpl-input-control"
                                      type="number"
                                      step="any"
                                      {...register("base", {})}
                                    />
                                  </div>
                                  <div className="col-md-5">
                                    (If different from Minimum Base or Category
                                    Base Value)
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* {pyqr && pyqr.show == "1" && (
                                <div className="col-md-12 margin-top-14px">
                                  <div className="form-group text-box-margin">
                                    <QRContainer>
                                      <QRImageWrapper>
                                        <QRImage
                                          src={`${pyqr.path}${pyqr.qr}`}
                                          alt="Payment QR Code"
                                        />
                                      </QRImageWrapper>
                                      <QRDetailsWrapper>
                                        <QRSectionTitle>
                                          Payment Details
                                        </QRSectionTitle>

                                        <QRDetailRow>
                                          <QRDetailLabel>Name:</QRDetailLabel>
                                          <QRDetailValue>
                                            {pyqr.name}
                                          </QRDetailValue>
                                        </QRDetailRow>

                                        <QRDetailRow>
                                          <QRDetailLabel>UPI ID:</QRDetailLabel>
                                          <QRDetailValue>
                                            {pyqr.mob}
                                          </QRDetailValue>
                                        </QRDetailRow>

                                        <QRDetailRow>
                                          <QRDetailLabel>Fees:</QRDetailLabel>
                                          <QRFeeValue>₹{pyqr.fee}</QRFeeValue>
                                        </QRDetailRow>

                                        <QRInstructions>
                                          Please scan the QR code to make the
                                          payment.
                                        </QRInstructions>
                                      </QRDetailsWrapper>
                                    </QRContainer>
                                  </div>
                                </div>
                              )} */}

                            <div className="col-md-12">
                              <button
                                className="button catadd-btns"
                                onClick={() => (savenew = 1)}
                                type="submit"
                                style={{
                                  marginLeft: "24px",
                                  borderRadius: "8px",
                                }}
                              >
                                SAVE AND ADD NEW
                              </button>
                              <button
                                className="button catadd-btns"
                                onClick={() => (savenew = 0)}
                                type="submit"
                                style={{
                                  marginLeft: "24px",
                                  borderRadius: "8px",
                                }}
                              >
                                Add Player
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Addplayers;
